<template>
  <div class="page ">
    <BindingMobile
      :telInput="telInput"
      @inputTelInfo="updTel"
      class="bg-white"
      style="margin-top:10px"
      verifyCodeType="MODIFY_PATIENT_MOBILE"
    ></BindingMobile>

    <p class="note">成功修改手机号后，只能用修改后的手机号进行登录</p>
    <van-button
      color="#1E8DFF"
      @click="submit"
      class="submit-btn width-351"
      :disabled="!(telInput.mobile && telInput.code)"
    >
      保 存
    </van-button>
  </div>
</template>

<script>
import BindingMobile from '@/components/BindingMobile.vue';
import { mapActions } from 'vuex';
export default {
  name: 'UpdMobile',
  components: {
    BindingMobile
  },
  data() {
    return {
      telInput: {
        mobile: '',
        code: ''
      }
    };
  },
  methods: {
    ...mapActions(['getUserInfo']),
    updTel(data) {
      if (data.type == 'mobile') {
        this.telInput.mobile = data.value;
      }
      if (data.type == 'code') {
        this.telInput.code = data.value;
      }
    },

    submit() {
      const { mobile, code } = this.telInput;
      const params = {
        mobile,
        verifyCode: code,
        verifyCodeType: 'MODIFY_PATIENT_MOBILE'
      };

      this.$fetch.updMobile(params).then(data => {
        if (data.code == -104) {
          this.$toast(data.message);
          this.getUserInfo();
          history.back();
        }
        if (data.code == -105) {
          this.$toast(data.message);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100%;
  .submit-btn {
    position: absolute;
    left: 0;
    top: 170px;
  }
}
.text {
  font-size: 13px;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  margin-top: 12px;
  display: inline-block;
}

.note {
  margin: 16px 12px 0;
  color: rgba(204, 204, 204, 1);
  line-height: 20px;
}
</style>
